import { ProductDetailsForm } from './ProductDetailsForm';
import { getCurrentFeatureCode } from '@/app/core/auth';
import { ContainerInputProps } from '@/app/features/products/common/components/input-props';
import { usaaProductDetailsValidator } from '@ssar-app/domain';

export const ProductDetails = (props: ContainerInputProps) => {
  const { keys } = props;
  return (
    <ProductDetailsForm
      stepKey={keys}
      moduleProps={{
        productName: getCurrentFeatureCode() || '',
      }}
      validator={usaaProductDetailsValidator}
    />
  );
};
